'use client';

import { type MouseEventHandler, forwardRef, useCallback, useContext } from 'react';

import { cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { DropdownRootContext } from './context/dropdown-root.context';
import type { DropdownClosePropsInterface } from './types/dropdown-close.types';

/**
 * @since 10.0.0
 */
export const DropdownClose = forwardRef<HTMLButtonElement, DropdownClosePropsInterface>(
  (props: DropdownClosePropsInterface, forwardedRef) => {
    const { children, onClick, tabIndex: _tabIndex, ...rest } = props;
    const { dropdown } = useContext(DropdownRootContext);

    const onClickHandler = useCallback<MouseEventHandler<HTMLButtonElement>>(
      (event) => {
        dropdown.onClickClose(event);
        onClick?.(event);
      },
      [dropdown, onClick],
    );

    return (
      <Slot
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Dropdown.Close"
        {...rest}
        onClick={onClickHandler}
        className={cx('c11n_dropdown__close', rest.className)}
      >
        {children}
      </Slot>
    );
  },
);

DropdownClose.displayName = 'Dropdown.Close';
